<template>
  <div>
    <el-form label-width="70px" ref="form" :rules="rules" :model="tmpltData">
      <el-row>
        <el-col :span="20">
          <el-form-item label="종류">
            <el-radio v-model="tempType" label="sms">SMS</el-radio>
            <el-radio v-model="tempType" label="e-mail">E-MAIL</el-radio>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="8">
          <el-form-item label="사용여부">
            <el-select v-model="value" placeholder="Select" size="medium">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="메세지 템플릿 선택" label-width="150px">
            <div class="table-input">
              <idc-input
                size="medium"
                v-model="tmpltData.tmpltNm"
                :placeholder="$t('messages.plInput')"
                disabled
              />
              <el-button
                type="primary"
                size="medium"
                @click="openSelectTemplatePopup"
              >
                {{ $t("messages.plSelectOp") }}
              </el-button>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="메세지 수신그룹 선택" label-width="150px">
            <div class="table-input">
              <idc-input
                size="medium"
                v-model="msgGroupData.tmpltNm"
                :placeholder="$t('messages.plInput')"
                disabled
              />
              <el-button
                type="primary"
                size="medium"
                @click="openMsgGroupPopup"
              >
                {{ $t("messages.plSelectOp") }}
              </el-button>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-divider /> -->
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="보낸사람">
            <el-select v-model="idc" value-key="idcCd" placeholder="select" size="medium">
              <el-option
                v-for="item in tmpltData.sendList"
                :key="item.idcCd"
                :label="item.idcCdNm"
                :value="item"
                disabled
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="이름" prop="otgorNm" v-if="tempType === 'e-mail'">
            <idc-input 
              v-model="tmpltData.otgorNm"
              size="medium"
              placeholder="발신자 이름"
              disabled
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="번호" v-if="this.tempType ==='sms'" label-width="90px"
            prop="otgorMphon"
          >
            <idc-input 
              v-model="tmpltData.otgorMphon"
              size="medium"
              placeholder="발신자 번호"
              disabled
            />
          </el-form-item>
          <el-form-item label="메일주소" v-else prop="otgorEmail" label-width="90px">
            <idc-input 
              v-model="tmpltData.otgorEmail"
              size="medium"
              placeholder="발신자 이메일"
              disabled
            />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- EMAIL FORM -->
      <template v-if="tempType == 'e-mail'">
        <el-row>
          <el-col>
            <el-form-item label="발송제목" label-width="90px" prop="emailTitle" ref="editorField">
              <idc-input
                v-model="tmpltData.emailTitle"
                size="medium"
                :placeholder="$t('messages.plInput')"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="ly-el-row-title">
          <el-form-item label="발송내용" label-width="90px" class="popover-row" prop="emailSbst">
            <idc-editor
              style="width:100%"
              :editorHtmlContent="this.tmpltData.emailSbst"
              @getEditorContent="getEditorContent"
            />
          </el-form-item>
        </el-row>
        <!--
        <el-row>
          <el-col :span="8">
            <el-form-item label="보낸사람">
              <idc-input
                v-model="input3"
                size="medium"
                :placeholder="$t('messages.plInput')"
              />
            </el-form-item>
          </el-col>
        </el-row> -->
      </template>
      <!-- SMS FORM -->
      <template v-else>
        <el-row>
          <el-col>
            <el-col>
              <el-form-item
                label="메세지"
                label-width="70px"
                prop="smsSbst"
              >
                <el-input
                  class="el-textarea"
                  type="textarea"
                  v-model="tmpltData.smsSbst"
                  size="medium"
                  @input="writeSbst(tmpltData.smsSbst)"
                />
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :span="8">
            <el-form-item label="입력사이즈" label-width="90px">
              <span>{{totalByte}}/90</span>
              <span>Byte</span>
            </el-form-item>
          </el-col>
        </el-row>
      </template>

      <el-row>
        <div class="ly-title">
          <h3 class="title-table" v-if="tempType == 'sms'">
            SMS 수신자 리스트 {{msgGroupData.tmpltNm}}
            <span style="color:skyblue" v-if="msgGroupData.msngRcvGroupTmpltId">
              [{{msgGroupData.tmpltNm}}]
            </span>
          </h3>
          <h3 class="title-table" v-else-if="tempType == 'e-mail'">
            E-mail 수신자 리스트
            <span style="color:skyblue" v-if="msgGroupData.msngRcvGroupTmpltId">
              [{{msgGroupData.tmpltNm}}]
            </span>
          </h3>
          <div class="ly-sort ly-sort-his">
            <div>
              <el-button
                plain
                size="small"
                type="primary"
                @click="$emit('openOrgModal')"
                >조직도
              </el-button>
              <el-button size="small" type="plus" @click="addMsngRcvGroupRcvrInfo">
                <i class="icon-Plus" />
              </el-button>
            </div>
          </div>
        </div>
        <idc-list
          :tableHeader="tableHeader"
          :tableData="tableData"
          :height="250"
        >
          <template #rcvrNm="{ scope }">
            <el-input
              size="small"
              v-model="scope.row.rcvrNm"
              :placeholder="$t('messages.plInput')"
              @change="appendUpdateData(scope.row)"
            />
          </template>
          <template #rcvrCntplc="{ scope }">
            <el-input
              size="small"
              v-model="scope.row.rcvrCntplc"
              :placeholder="$t('messages.plInput')"
              @change="appendUpdateData(scope.row)"
            />
          </template>
          <template #rcvrEmail="{ scope }">
            <el-input
              size="small"
              v-model="scope.row.rcvrEmail"
              :placeholder="$t('messages.plInput')"
              @change="appendUpdateData(scope.row)"
            />
          </template>
          <template #deleteBtn="{ scope }">
            <el-button type="minus" @click="appendDeleteData(scope.row, scope.$index)"
            >
                <i class="icon-Minus" />
              </el-button>
          </template>
        </idc-list>
        <div class="ly-detail-footer">
          <!-- <el-button type="save" @click="modifySubData">
              {{ $t("messages.btnModify") }}
            </el-button> -->
          <el-button type="save" @click="tmpPost">
              즉시발송
            </el-button>
        </div>
      </el-row>
    </el-form>

    <!-- 템플릿 선택 팝업 -->
    <idc-modal
      :visible.sync="modalSelectTemplate"
      title="템플릿 선택"
      width="1550px"
    >
      <template #content>
        <view-template-list
          :tempType="tempType"
          @getTmplt="getTmplt"
        />
      </template>
    </idc-modal>

    <!-- 수신그룹 선택 팝업 -->
    <idc-modal
      :visible.sync="modalSelectMsgGroup"
      title="템플릿 선택"
      width="1550px"
    >
      <template #content>
        <select-msg-group-modal @getMsgGroup="getMsgGroup"/>
      </template>
    </idc-modal>
  </div>
</template>

<script>
import commonMixin from "@/mixins/commonMixin";
import IdcInput from "@/components/common/IdcInput.vue";
import IdcModal from "@/components/common/IdcModal.vue";
import IdcList from "@/components/common/IdcList.vue";
import IdcEditor from "@/components/common/IdcEditor.vue";
import ViewTemplateList from "@/components/listComponents/safetyManageComponents/ViewTemplateList.vue";
import SelectMsgGroupModal from './SelectMsgGroupModal.vue';

export default {
  components: {
    IdcList,
    IdcModal,
    IdcInput,
    IdcEditor,
    ViewTemplateList,
    SelectMsgGroupModal,
  },
  mixins: [commonMixin],
  computed: {
    modalSelectTemplate: {
      get: function() {
        return this.$store.getters['popupManageStore/getModalSelectTemplate'];
      },
      set: function(newValue) {
        this.$store.commit('popupManageStore/setModalSelectTemplate', newValue);
      }
    },
    modalSelectMsgGroup: {
      get: function() {
        return this.$store.getters['popupManageStore/getModalSelectMsgGroup'];
      },
      set: function(newValue) {
        this.$store.commit('popupManageStore/setModalSelectMsgGroup', newValue);
      }
    },
  },
  watch: {
    tempType() {
      this.initForm();
    },
  },
  data() {
    return {
      options: [
        {
          value: "사용",
          label: "사용",
        },
        {
          value: "미사용",
          label: "미사용",
        },
      ],
      value: "사용",
      templateSelect: "",
      groupSelect: "",

      tableHeader: [
        {
          prop: "rcvrNm",
          label: "수신자명",
          width: "8",
          columnType: "custom",
        },
        {
          prop: "rcvrEmail",
          label: "이메일",
          width: "8",
          columnType: "custom",
        },
        {
          prop: "rcvrCntplc",
          label: "연락처",
          width: "13",
          columnType: "custom",
        },
        {
          prop: "deleteBtn",
          label: "",
          width: "2",
          columnType: "custom",
        },
      ],
      tableData: [],
      tempType: "sms",
      tmpltData: {
        msngTmpltId: '',
        tmpltNm: '',
        emailTitle: '',
        emailSbst: '',
        smsSbst: '',
        sendList: [],
        otgorMphon: '',
        otgorEmail: '',
        // 발신자 이름
        otgorNm: "고객지원팀",
      },
      msgGroupData: {
        msngRcvGroupTmpltId: '',
        tmpltNm: '',
      },
      updateList: {},
      idc: {},
      rules: {
        otgorNm: [{ required: true, message: "발신자 이름은 필수입니다.", trigger: "blur" }],
        otgorMphon: [{ required: true, message: "발신자 번호는 필수입니다.", trigger: "blur" }],
        otgorEmail: [{ required: true, message: "발신자 메일주소는 필수입니다.", trigger: "blur" }],
        smsSbst: [{ required: true, message: "메세지내용은 필수입니다.", trigger: "blur" }],
        emailTitle: [{ required: true, message: "발송제목은 필수입니다.", trigger: "blur" }],
        emailSbst: [{ required: true, message: "발송내용은 필수입니다.", trigger: "blur" }],
      },
      totalByte: 0,
    }
  },
  methods: {
    openSelectTemplatePopup() {
      this.$store.commit("popupManageStore/setModalSelectTemplate", true);
    },
    getTmplt(tmpltData) {
      this.idc = {};
      this.tmpltData = tmpltData;
      this.tmpltData.otgorNm = "고객지원팀";
      if (this.tmpltData.sendList.length === 1) {
        this.idc = this.tmpltData.sendList[0];
        this.tmpltData.otgorMphon = this.idc.otgorMphon;
        this.tmpltData.otgorEmail = this.idc.otgorEmail;
      }
      if (this.tmpltData.smsSbst) {
        this.writeSbst(this.tmpltData.smsSbst);
      }
    },
    getEditorContent(text) {
      this.tmpltData.emailSbst = text;
    },
    initForm() {
      this.tmpltData = {
        msngTmpltId: '',
        tmpltNm: '',
        emailTitle: '',
        emailSbst: '',
        smsSbst: '',
        sendList: [],
        otgorMphon: '',
        otgorEmail: '',
        // 발신자 이름
        otgorNm: "고객지원팀",
      };
      this.idc = {};
      this.msgGroupData = {
        msngRcvGroupTmpltId: '',
        tmpltNm: '',
      };
      this.totalByte = 0;
      this.$store.commit('tempManageStore/setPopCurrentTmplCd', {});
    },
    openMsgGroupPopup() {
      this.$store.commit("popupManageStore/setModalSelectMsgGroup", true);
    },
    getMsgGroup(msgGroup, subData) {
      this.msgGroupData = msgGroup;
      this.tableData = subData;
    },
    async modifySubData() {
      if (!confirm("수정하시겠습니까?")) return;
      const insertList = this.tableData.filter(data=>!data.msngRcvGroupRcvrInfoSeq);
      await Promise.all(insertList.map(data=>this.createMsngRcvGroupRcvrInfo(data)));
      const updateList = Object.values(this.updateList);
      await Promise.all(updateList.map(data=>this.putMsngRcvGroupRcvrInfo(data)));
      alert("수정되었습니다.");
      this.getMsngRcvGroupRcvrInfoList(this.msgGroupData.msngRcvGroupTmpltId);
    },
    appendUpdateData(row) {
      this.updateList[row.msngRcvGroupRcvrInfoSeq] = row;
    },
    appendDeleteData(row, idx) {
      row.delYn = "Y"
      this.tableData.splice(idx, 1);
      if (row.msngRcvGroupRcvrInfoSeq) {
        // 저장되있는 데이터인 경우
        this.updateList[row.msngRcvGroupRcvrInfoSeq] = row;
      }
    },
    async getMsngRcvGroupRcvrInfoList(msngRcvGroupTmpltId) {
      const { data } = await this.$BIZ_SERVICE
        .post(this.$API_URLS.Opr.getMsngRcvGroupRcvrInfoList,
          {msngRcvGroupTmpltId,
            paging: false, delYn: 'N'});
      const { list } = JSON.parse(data.resData);
      this.tableData = list;
    },
    async createMsngRcvGroupRcvrInfo(data) {
      await this.$BIZ_SERVICE
        .post(this.$API_URLS.Opr.postMsngRcvGroupRcvrInfo, data);
    },
    async putMsngRcvGroupRcvrInfo(data) {
      await this.$BIZ_SERVICE
        .post(this.$API_URLS.Opr.putMsngRcvGroupRcvrInfo, data);
    },
    async addMsngRcvGroupRcvrInfo() {
      this.tableData.push({rcvrNm: '', rcvrEmail: '', rcvrCntplc: '', delYn: 'N',
        msngRcvGroupTmpltId: this.msgGroupData.msngRcvGroupTmpltId})
    },
    async tmpPost() {
      if (!this.validateForm()) {
        alert("필수 값을 입력하세요.");
        return;
      }
      const rcvList = this.filterSubList();
      if (rcvList.length === 0) {
        alert("보낼 수 있는 수신자 정보가 없습니다.");
        return;
      }
      const headers = {'Content-Type':'application/json'}
      const params = {
        ...this.tmpltData,
        ...this.msgGroupData,
        ...this.idc,
        tempType: this.tempType,
        rcvList,
      }
      // 발신자 이름 otgorNm
      await this.$BIZ_SERVICE.post(
        this.$API_URLS.Opr.postTmplMsg, params, {headers}
      );
      alert("발송되었습니다.")
    },
    resetForm() {
      this.$refs.form.clearValidate();
      this.initForm();
      this.tableData = [];
      this.totalByte = 0;
    },
    validateForm() {
      let result = true;
      this.$refs.form.validate((valid) => {
        if (!valid) {
          result = false;
          return;
        }
      });
      return result;
    },
    filterSubList() {
      let requiredKey = '';
      if (this.tempType === 'sms') {
        requiredKey = 'rcvrCntplc';
      } else {
        requiredKey = 'rcvrEmail';
      }
      const valid = (data)=> {
        let result = true;
        if (!data.rcvrNm || !data[requiredKey]) {
          result = false;
        }
        return result;
      }
      const otgorList = this.tableData.filter(valid);
      return otgorList;
    },
    writeSbst(val) {
      let tbyte = 0; let rlen = 0; let char = ""; let max = 90;
      for (let i = 0; i < val.length; i++) {
        char = val.charAt(i);
        if (escape(char).length > 4) {
          tbyte += 2;
        } else {
          tbyte += 1;
        }
        if (tbyte <= max) {
          rlen = i + 1;
        }
      }
      if (tbyte > max) {
        alert("메세지는 최대 90byte를 초과할 수 없습니다.");
        let val2 = val.substr(0, rlen); //90byte넘은거 삭제
        this.tmpltData.smsSbst = val2;
      } else {
        this.totalByte = tbyte;
      }
    },
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-row {
    margin-bottom: -10px;
  }
  .el-divider {
    margin: 15px 0;
  }
}
.table-input {
  display: flex;
  gap: 5px;
  align-items: flex-end;
}
.el-textarea {
  ::v-deep {
    textarea {
      font-family: "NotoSansKR";
      width: 100%;
      height: 200px;
      resize: none;
      border-radius: 5px;
      border-color: #e5e5e5;
      padding: 10px;
      &:focus {
        outline: none;
      }
    }
  }
}
</style>
